import { Switch, type SwitchProps } from '@mantine/core';
import type { ChangeEvent } from 'react';
import type { Except, Merge, SetRequired } from 'type-fest';
import { LabelNode } from '../getLabelNode';
import type { Controlled_InputWithLabelProps } from './types';

export type Controlled_BooleanSwitchInputProps = Merge<
    Except<SetRequired<SwitchProps, 'readOnly'>, 'checked'>,
    Except<Controlled_InputWithLabelProps<false, boolean>, 'nullable'>
>;

export const Controlled_BooleanSwitchInput = ({
    value,
    onChange,
    label,
    labelInfo,
    readOnly,
    color,
    ...props
}: Controlled_BooleanSwitchInputProps) => {
    const handleChange =
        onChange ?
            (event: ChangeEvent<HTMLInputElement>) =>
                onChange(event.currentTarget.checked)
        :   undefined;

    return (
        <Switch
            {...props}
            checked={value ?? false}
            onChange={readOnly ? undefined : handleChange}
            label={
                label && (
                    <LabelNode
                        label={label}
                        labelInfo={labelInfo}
                    />
                )
            }
            color={color ?? (readOnly ? 'gray' : undefined)}
        />
    );
};
